import { EmployeeColumnFilterValueProps } from "@/pages/employees/index/employee-column-filter-renderers.ts";
import { useDepartmentsTree } from "@/queries/use-departments.query.ts";
import { ApiEmployeeColumnOptionId } from "@/types/employees/employee-column.types.ts";
import { Multiselect } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

/**
 * Департамент выбирается деревом, как в старой панели фильтров
 * (`renderFilterDepartments`): плоский список опций каталога теряет иерархию.
 * Значение то же — id департаментов в `option_ids`.
 */
export function EmployeeDepartmentFilterValue({
  column,
  filter,
  onChange,
}: EmployeeColumnFilterValueProps) {
  const { t } = useTranslation();
  const departments = useDepartmentsTree();

  return (
    <Multiselect
      label={column.title}
      options={departments.data}
      values={filter.option_ids ?? []}
      onChange={(value) =>
        onChange({
          option_ids: value.filter(
            (item): item is ApiEmployeeColumnOptionId => item !== null && item !== undefined
          ),
        })
      }
      searchable
      isClearable
      isLoading={departments.isLoading}
      emptyTitle={t("common:select")}
    />
  );
}
